import React, { useState } from 'react';

import {
  Breakpoints,
  Container,
  LoaderSpinner,
} from '@vw-marketing/us-components';

import { ErrorMessage } from './components/error-message';
import {
  fetchModelsConfigData,
  ModelsConfigResponse,
} from './fetch-data/models-config';
import { ModelsCarousel } from './app/models-carousel/ModelsCarousel';
import { ModelsCarouselContextProvider } from './context/ModelsCarouselContext';
import { ModelsConfigContext } from './context/models-config-context';
import { SharedConfigsContext } from './context/shared-configs-context';
import { useProvideSharedConfigs } from './hooks/use-shared-configs';

interface AppProps {
  baseUrl?: string;
}

export const App = ({ baseUrl }: AppProps) => {
  const sharedConfigs = useProvideSharedConfigs();
  const [modelsConfigData, setModelsConfigData] = useState<
    ModelsConfigResponse | undefined
  >(undefined);
  const error = modelsConfigData?.errorHandling?.[0];
  const data = modelsConfigData?.fetchedModelsConfig;
  const loading = !modelsConfigData;

  loading && fetchModelsConfigData(setModelsConfigData);

  return (
    <ModelsCarouselContextProvider>
      {error && <ErrorMessage message1={error.errorMessage} />}
      {data && (
        <ModelsConfigContext.Provider value={data}>
          <SharedConfigsContext.Provider value={sharedConfigs}>
            <Container
              padding={{
                top: {
                  [Breakpoints.default]: 'static450',
                  [Breakpoints.b560]: 'static510',
                  [Breakpoints.b1280]: 'static520',
                },
                bottom: {
                  [Breakpoints.default]: 'static450',
                  [Breakpoints.b560]: 'static510',
                  [Breakpoints.b1280]: 'static520',
                },
              }}
              stretchContent
            >
              <ModelsCarousel />
            </Container>
          </SharedConfigsContext.Provider>
        </ModelsConfigContext.Provider>
      )}
      {loading && <LoaderSpinner />}
    </ModelsCarouselContextProvider>
  );
};
